// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var Curry = require("@rescript/std/lib/js/curry.js");
var React = require("react");
var Context = require("../../provider/Context.bs.js");
var Atom_Box = require("../atom/Atom_Box.bs.js");
var Atom_Cta = require("../atom/Atom_Cta.bs.js");
var SetFocus = require("../../hook/SetFocus.bs.js");
var Atom_Cell = require("../atom/Atom_Cell.bs.js");
var Atom_Text = require("../atom/Atom_Text.bs.js");
var Belt_Array = require("@rescript/std/lib/js/belt_Array.js");
var Util_Array = require("../../util/Util_Array.bs.js");
var Atom_Column = require("../atom/Atom_Column.bs.js");
var Atom_Cta_Ds = require("../atom/Atom_Cta_Ds.bs.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Type_Header = require("../../type/Type_Header.bs.js");
var Atom_Text_Ds = require("../atom/Atom_Text_Ds.bs.js");
var Particle_Css = require("../particle/Particle_Css.bs.js");
var Particle_zIndex = require("../particle/Particle_zIndex.bs.js");
var UseClickOutside = require("../../hook/UseClickOutside.bs.js");
var Particle_Screen_Ds = require("../particle/Particle_Screen_Ds.bs.js");
var Particle_Spacer_Ds = require("../particle/Particle_Spacer_Ds.bs.js");
var Particle_Accessibility = require("../particle/Particle_Accessibility.bs.js");
var Particle_Background_Ds = require("../particle/Particle_Background_Ds.bs.js");
var Particle_Screen_Constants = require("../particle/Particle_Screen_Constants.bs.js");

function computePosition(alignPosition, spacer) {
  var iteratee = function (alignPosition, spacer) {
    var calculatedDistance_1 = [
      "add",
      {
        NAME: "percent",
        VAL: 100
      },
      Particle_Css.spacerSizeInside(spacer)
    ];
    var calculatedDistance = {
      NAME: "calc",
      VAL: calculatedDistance_1
    };
    if (alignPosition === "BottomLeft") {
      return {
              positionValues: {
                top: calculatedDistance,
                bottom: "auto",
                left: "auto",
                right: calculatedDistance
              },
              position: "absolute"
            };
    } else if (alignPosition === "FullWindow") {
      return {
              positionValues: {
                top: "zero",
                bottom: "zero",
                left: "zero",
                right: "zero"
              },
              position: "fixed"
            };
    } else if (alignPosition === "BottomRight") {
      return {
              positionValues: {
                top: calculatedDistance,
                bottom: "auto",
                left: calculatedDistance,
                right: "auto"
              },
              position: "absolute"
            };
    } else if (alignPosition === "TopLeft") {
      return {
              positionValues: {
                top: "auto",
                bottom: calculatedDistance,
                left: "auto",
                right: calculatedDistance
              },
              position: "absolute"
            };
    } else {
      return {
              positionValues: {
                top: "auto",
                bottom: calculatedDistance,
                left: calculatedDistance,
                right: "auto"
              },
              position: "absolute"
            };
    }
  };
  return Particle_Screen_Ds.zipWith(iteratee, alignPosition, spacer);
}

var containerBlockspace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("XS"));

var closeButtonRules = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [
      CssJs.position("absolute"),
      CssJs.top("zero"),
      CssJs.right("zero")
    ]);

var closeButtonWidth = Particle_Screen_Ds.catOption(0, Atom_Cta_Ds.getPredefinedWidth(Atom_Cta_Ds.make({
              TAG: /* Player */15,
              _0: /* CloseTooltip */3
            })));

var contentRules = Particle_Screen_Ds.map((function (width) {
        return [CssJs.paddingRight(CssJs.px(width))];
      }), closeButtonWidth);

function Organism_Tooltip$Internal(Props) {
  var backgroundOpt = Props.background;
  var children = Props.children;
  var clickOutsideBehavior = Props.clickOutsideBehavior;
  var closeButton = Props.closeButton;
  var content = Props.content;
  var containerBlockspaceOpt = Props.containerBlockspace;
  var position = Props.position;
  var status = Props.status;
  var zIndex = Props.zIndex;
  var rules = Props.rules;
  var closeButtonAriaLabel = Props.closeButtonAriaLabel;
  var background = backgroundOpt !== undefined ? Caml_option.valFromOption(backgroundOpt) : Particle_Background_Ds.tooltip;
  var containerBlockspace$1 = containerBlockspaceOpt !== undefined ? Caml_option.valFromOption(containerBlockspaceOpt) : containerBlockspace;
  var ref = React.useRef(null);
  var match = Context.I18n.getState(undefined);
  var match$1 = match.labels.accessibility;
  var closeAriaLabel = Belt_Option.getWithDefault(closeButtonAriaLabel, match$1.close);
  var handleClickOutside = React.useMemo((function () {
          return function (param) {
            if (status || !clickOutsideBehavior) {
              return ;
            } else {
              return Curry._1(clickOutsideBehavior._0, undefined);
            }
          };
        }), [
        status,
        clickOutsideBehavior
      ]);
  UseClickOutside.make(ref, handleClickOutside);
  var match$2 = closeButton ? [
      Caml_option.some(contentRules),
      React.createElement(Atom_Box.make, {
            children: React.createElement(Atom_Cta.Button.make, {
                  accessibility: Particle_Accessibility.make(undefined, undefined, undefined, undefined, undefined, undefined, undefined, closeAriaLabel, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  onClick: closeButton._0,
                  style: {
                    TAG: /* Player */15,
                    _0: /* CloseTooltip */3
                  }
                }),
            rules: closeButtonRules
          })
    ] : [
      undefined,
      null
    ];
  var display = status ? CssJs.display("none") : CssJs.display("block");
  var containerRules = Particle_Screen_Ds.map((function (p) {
          var baseRules = [
            CssJs.top(p.positionValues.top),
            CssJs.bottom(p.positionValues.bottom),
            CssJs.left(p.positionValues.left),
            CssJs.right(p.positionValues.right),
            CssJs.position(p.position),
            display
          ];
          var zIndexRule = Belt_Option.getWithDefault(Belt_Option.map(zIndex, (function (zIndex) {
                      return Util_Array.pure(Particle_zIndex.Particle_zIndex_Css.toCss(zIndex));
                    })), []);
          return Belt_Array.concat(zIndexRule, baseRules);
        }), position);
  var rules$1 = Particle_Screen_Ds.$$Array.concatMany(Util_Array.catOption([
            rules,
            Caml_option.some(containerRules)
          ]));
  var tmp = {
    width: Particle_Screen_Constants.oneHundredPctWidth,
    height: Particle_Screen_Constants.oneHundredPctHeight,
    children: null,
    identifier: "closeable-content"
  };
  var tmp$1 = match$2[0];
  if (tmp$1 !== undefined) {
    tmp.rules = Caml_option.valFromOption(tmp$1);
  }
  var tooltipContent = React.createElement(Atom_Column.make, {
        background: background,
        blockSpace: containerBlockspace$1,
        children: React.createElement(Atom_Cell.make, tmp, match$2[1], content),
        identifier: "closeable-container",
        rules: rules$1
      });
  return React.createElement(Atom_Box.make, {
              children: null,
              ref_: ref
            }, tooltipContent, children);
}

var Internal = {
  computePosition: computePosition,
  containerBlockspace: containerBlockspace,
  closeButtonRules: closeButtonRules,
  closeButtonWidth: closeButtonWidth,
  contentRules: contentRules,
  make: Organism_Tooltip$Internal
};

function Organism_Tooltip$Player(Props) {
  var isOpen = Props.isOpen;
  var onClose = Props.onClose;
  var onClickOutside = Props.onClickOutside;
  var align = Props.align;
  var distance = Props.distance;
  var content = Props.content;
  var children = Props.children;
  var zIndex = Props.zIndex;
  var closeButtonAriaLabel = Props.closeButtonAriaLabel;
  var status = isOpen ? /* Show */0 : /* Hide */1;
  var match = onClose !== undefined ? (
      onClickOutside !== undefined ? [
          /* WithCloseButton */{
            _0: onClose
          },
          /* Close */{
            _0: onClickOutside
          }
        ] : [
          /* WithCloseButton */{
            _0: onClose
          },
          /* DoNothing */0
        ]
    ) : (
      onClickOutside !== undefined ? [
          /* WithoutCloseButton */0,
          /* Close */{
            _0: onClickOutside
          }
        ] : [
          /* WithoutCloseButton */0,
          /* DoNothing */0
        ]
    );
  var distance$1 = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, distance);
  var position = computePosition(Particle_Screen_Ds.make(undefined, undefined, align, undefined, undefined, "FullWindow"), distance$1);
  var rules = Belt_Option.map(zIndex, (function (zIndex) {
          return Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [CssJs.zIndex(zIndex)]);
        }));
  var tmp = {
    children: children,
    clickOutsideBehavior: match[1],
    closeButton: match[0],
    content: content,
    position: position,
    status: status
  };
  if (rules !== undefined) {
    tmp.rules = Caml_option.valFromOption(rules);
  }
  if (closeButtonAriaLabel !== undefined) {
    tmp.closeButtonAriaLabel = Caml_option.valFromOption(closeButtonAriaLabel);
  }
  return React.createElement(Organism_Tooltip$Internal, tmp);
}

var Player = {
  make: Organism_Tooltip$Player
};

var blockSpace = Particle_Screen_Ds.make(undefined, undefined, Caml_option.some(Particle_Spacer_Ds.makeHorizontal("M")), undefined, undefined, Particle_Spacer_Ds.makeHorizontalWithLeftAndRight("M", "XXS", undefined));

var maxWidth = Particle_Screen_Ds.make(undefined, undefined, CssJs.px(611), undefined, undefined, CssJs.vw(100));

function Organism_Tooltip$UserPref$Content(Props) {
  var onClose = Props.onClose;
  var loginButtonId = Props.loginButtonId;
  var paramButtonId = Props.paramButtonId;
  var settingsHref = Props.settingsHref;
  var match = Context.I18n.getState(undefined);
  var match$1 = match.labels.userPref;
  var handleSecurityCenterClick = function (param) {
    Curry._1(onClose, undefined);
  };
  var onBlur = function (param) {
    SetFocus.ById.make(loginButtonId);
    Curry._1(onClose, undefined);
  };
  return React.createElement(Atom_Cell.make, {
              blockSpace: blockSpace,
              maxWidth: maxWidth,
              children: React.createElement(Atom_Column.make, {
                    alignItems: Particle_Screen_Constants.alignItemsFlexStart,
                    children: null,
                    innerSpace: Particle_Screen_Constants.sInnerSpace,
                    justifyContent: Particle_Screen_Constants.justifyContentSpaceBetween
                  }, React.createElement(Atom_Text.make, {
                        children: match$1.message,
                        style: Atom_Text_Ds.UserPref.makeUserPrefMessage
                      }), React.createElement(Atom_Cta.Link.make, {
                        href: settingsHref,
                        id: paramButtonId,
                        label: match$1.setupCookies,
                        onBlur: onBlur,
                        onClick: handleSecurityCenterClick,
                        style: {
                          TAG: /* UserPref */25,
                          _0: /* OpenSecurityCenter */0
                        }
                      }))
            });
}

var Content = {
  make: Organism_Tooltip$UserPref$Content
};

var containerBlockspace$1 = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeVertical("M"));

function Organism_Tooltip$UserPref(Props) {
  var status = Props.status;
  var onClose = Props.onClose;
  var children = Props.children;
  var loginButtonId = Props.loginButtonId;
  var paramButtonId = Props.paramButtonId;
  var settingsHref = Props.settingsHref;
  var content = React.createElement(Organism_Tooltip$UserPref$Content, {
        onClose: onClose,
        loginButtonId: loginButtonId,
        paramButtonId: paramButtonId,
        settingsHref: settingsHref
      });
  var position = Particle_Screen_Ds.make(undefined, undefined, {
        positionValues: {
          top: CssJs.px(Type_Header.Constants.height.m),
          bottom: "auto",
          left: "auto",
          right: "zero"
        },
        position: "fixed"
      }, undefined, undefined, {
        positionValues: {
          top: CssJs.px(Type_Header.Constants.height.default),
          bottom: "auto",
          left: "auto",
          right: "zero"
        },
        position: "fixed"
      });
  return React.createElement(Organism_Tooltip$Internal, {
              children: children,
              clickOutsideBehavior: /* DoNothing */0,
              closeButton: /* WithoutCloseButton */0,
              content: content,
              containerBlockspace: containerBlockspace$1,
              position: position,
              status: status,
              zIndex: {
                TAG: /* Exact */0,
                _0: /* TooltipUserPref */17
              }
            });
}

var UserPref = {
  blockSpace: blockSpace,
  maxWidth: maxWidth,
  Content: Content,
  containerBlockspace: containerBlockspace$1,
  make: Organism_Tooltip$UserPref
};

exports.Internal = Internal;
exports.Player = Player;
exports.UserPref = UserPref;
/* containerBlockspace Not a pure module */
